import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import customWebSystems from '../../../../images/customWebSystems.png';
import LearnMoreCommon from '../LearnMoreCommon';

const CustomSoftwareDevelopmentPage = props => {
    const { t } = props;
    return (
        <LearnMoreCommon
            cardMediaImage={customWebSystems}
            cardMediaTitle={t(
                'landingPage.serviceSection.services.customSoftwareDevelopment.header'
            )}
            headerTitle={t(
                'landingPage.serviceSection.services.customSoftwareDevelopment.header'
            )}
            firstBlockText={t(
                'landingPage.serviceSection.services.customSoftwareDevelopment.learnMore.firstBlock'
            )}
            contactUsDescription={t(
                'landingPage.serviceSection.services.customSoftwareDevelopment.learnMore.contactUs'
            )}
            googleEventCategory="Services - CustomSoftwareDevelopmentPage"
        />
    );
};

export default compose(withTranslation())(CustomSoftwareDevelopmentPage);
